import { createContext } from "react";

const AISContext = createContext(null);

export default AISContext;